import { apiClient } from '@services/api-client'
import { MutationOptions, SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation } from '@tanstack/react-query'
import { Register, RegisterResponse } from 'types/api'
import { BaseParams } from 'types/utils'

export function useRegister(
  options: MutationOptions<BaseParams<Register, 'POST'>, RegisterResponse> = {}
) {
  const onError = useOnError()

  async function register({ body }: BaseParams<Register, 'POST'>) {
    const res = await apiClient.post<RegisterResponse>(
      `${SNA_PREFIX}auth/register`,
      body
    )
    return res.data
  }

  return useMutation({
    ...options,
    mutationFn: register,
    onError
  })
}
